<template>
  <v-main class="home pa-5 d-flex align-sm-center" fluid fill-height>
    <v-img
      v-if="isMobile"
      max-width="100px"
      class="mx-auto my-5"
      contain
      src="../assets/img/logo.svg"
    ></v-img>
    <h1 v-if="isMobile" class="home-title text-center">
      “Sin duda la forma más sencilla y rápida de llegar al mundo digital”
    </h1>
    <v-btn v-if="isMobile" class="my-button" color="#FF1969" block dark>
      ¿Como aparecer en Rel Menú?
    </v-btn>
    <h2 v-if="isMobile" class="home-subtitle text-center">
      Las empresas y negocios locales que ya usan nuestro servicio.
    </h2>

    <v-list v-if="isMobile" two-line color="transparent">
      <v-list-item
        class="company-card-home"
        v-for="company in companies"
        :key="company.id"
        :to="'/' + company.id"
      >
        <v-list-item-avatar
          class="company-img-home my-2"
          height="60"
          width="60"
        >
          <v-img :src="company.img" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="item-title"
            v-text="company.name"
          ></v-list-item-title>

          <v-list-item-subtitle
            class="item-description"
            v-text="company.type"
          ></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            :to="'/' + company.id"
            class="my-button"
            color="#50C983"
            small
            dark
          >
            Menú
            <v-img class="ml-3" src="../assets/img/menu-w.svg" />
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-img
      v-if="!isMobile"
      max-width="40%"
      class="mx-auto"
      contain
      src="../assets/img/logo.svg"
    ></v-img>
    <h1 v-if="!isMobile" class="home-subtitle text-center">
      Ábrelo en tu móvil, nos estamos preparando para que puedas pedir en tu computadora.
    </h1>
  </v-main>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "Home",

  components: {},

  data: () => ({
    companies: [],
  }),

  created() {
    this.getCompanies();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  methods: {
   async getCompanies() {
      await db
        .collection("companies").where("isActive", "==", true)
        .get()
        .then((res) => {
          res.forEach((body) => {
            this.companies.push({
              id: body.id,
              name: body.data().name,
              img: body.data().img,
              type: body.data().type,
            });
          });
        });
    },
  },
};
</script>


